module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rankError"
  }, _vm._l((_vm.paperData), function(items, indexs) {
    return _c('ul', {
      staticClass: "rankErrorBox"
    }, _vm._l((items.sentences), function(item, index) {
      return _c('li', {
        staticClass: "rankErrorTwo clearfix"
      }, [_c('p', {
        staticClass: "rankErrorTit fl",
        attrs: {
          "title": item.content
        }
      }, [_vm._v(_vm._s(_vm.matchCont(item.content)))]), _vm._v(" "), _c('div', {
        staticClass: "fr"
      }, [_c('div', {
        staticClass: "progress"
      }, [_c('span', {
        staticClass: "progressChild bgGreen",
        style: ({
          width: (item.avgScore / 100) * 100 + '%'
        })
      })]), _vm._v(" "), _c('div', [_c('span', {
        staticClass: "errorNum"
      }, [_vm._v("平均分: "), _c('i', {
        class: {
          green: item.avgScore >= 0
        }
      }, [_vm._v(_vm._s(item.avgScore >= 0 ? _vm.toMathThree(item.avgScore) : "--"))]), _vm._v(" 分")])])])])
    }))
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49a57263","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rankError/rankErrorText.vue
// module id = 1197
// module chunks = 1